import CloseIcon from "@mui/icons-material/Close";
import Autocomplete from "@mui/material/Autocomplete";
import Stack from "@mui/material/Stack";
import TextField from "@mui/material/TextField";
import { ChangeEvent, useEffect, useState } from "react";
import styles from "./style.module.scss";

interface AutoCompleteCityProps {
  list: any;
  setSearchText: (text: string) => void;
  searchText: string;
  selectedItem: any;
  setSelectedItem: (user: null | any) => void;
}

export default function AutoCompleteCity({
  list,
  setSearchText,
  searchText,
  selectedItem,
  setSelectedItem,
}: AutoCompleteCityProps) {
  const [allList, setAllList] = useState<any>(list ? list : []);

  useEffect(() => {
    setAllList(list);
  }, [list]);

  const handleInputChange = (value: any | null) => {
    setSelectedItem(value);
  };

  const handleSearch = (e: ChangeEvent<HTMLInputElement>) => {
    setSearchText(e.target.value);
  };

  return (
    <Stack spacing={2}>
      {selectedItem ? (
        <div
          className={`${styles.displayAlign} ${styles.selectedNameAutoComplete}`}
        >
          <div className={styles.displayAlign}>
            <p>{selectedItem.city ? selectedItem.city : ""}</p>
          </div>

          <CloseIcon
            sx={{ cursor: "pointer" }}
            onClick={() => {
              setSelectedItem(null);
            }}
          />
        </div>
      ) : (
        <Autocomplete
          autoFocus
          defaultValue={selectedItem}
          id="free-solo-demo"
          freeSolo
          options={allList}
          getOptionLabel={(option: any) => {
            return option?.city;
          }}
          onChange={(_, newValue: any) => {
            handleInputChange(newValue);
          }}
          renderOption={(props, option) => {
            return (
              <li {...props}>
                {option?.city ? option?.city : "Not Available"}
              </li>
            );
          }}
          renderInput={(params) => (
            <TextField
              {...params}
              placeholder="City"
              value={searchText}
              onChange={(e: any) => handleSearch(e)}
              className={styles.input}
            />
          )}
        />
      )}
    </Stack>
  );
}
